import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles({
  '@keyframes glow': {
    '0%, 100%': { opacity: 0.5 },
    '50%': { opacity: 1 }
  },
  container: {
    padding: '15px 10px',
    borderRadius: 10,
    display: 'flex'
  },
  listItemText: {
    height: 56,
    width: '100%',
    backgroundColor: '#f7f7f7',
    color: '#f7f7f7',
    animation: '$glow 1.5s ease-in-out infinite'
  }
});

export default function ChatLoading() {
  const classes = useStyles();

  return (
    <List>
      {[...new Array(5)].map((el, idx) => (
        <ListItem key={`loading-${idx}`} className={classes.container}>
          <ListItemText
            classes={{
              root: classes.listItemText
            }}
            primary="Loading"
          />
        </ListItem>
      ))}
    </List>
  );
}
